import LocalForageBackup from 'components/backup/backup';
// eslint-disable-next-line
import LocalForageRestore from 'components/backup/restore';
import localforage from 'localforage';
import { Notification } from 'notification/notification';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Container,
  Media,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';
import { syncRequests } from 'services/auth';
import { setSyncRequests } from 'services/auth';
import { getUsername } from 'services/auth';
import { logout } from 'services/auth';

const AdminNavbar = (props) => {
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);
  return (
    <>
      <Navbar className='navbar-top navbar-dark' expand='md' id='navbar-main'>
        <Container fluid>
          <Link
            className='h4 mb-0 text-white text-uppercase d-none d-lg-inline-block'
            to='/admin'
          >
            {props.brandText}
          </Link>
          <Nav className='align-items-center d-none d-md-flex' navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className='pr-0' nav>
                <Media className='align-items-center'>
                  <span className='avatar avatar-sm rounded-circle'>
                    <img
                      alt='...'
                      src={require('../../assets/img/theme/user.png').default}
                    />
                  </span>
                  <Media className='ml-2 d-none d-lg-block'>
                    <span className='mb-0 text-sm font-weight-bold'>
                      {getUsername()}
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu className='dropdown-menu-arrow' right>
                <DropdownItem className='noti-title' header tag='div'>
                  <h6 className='text-overflow m-0'>Bem vindo!</h6>
                </DropdownItem>
                <DropdownItem to='/admin/user-profile' tag={Link}>
                  <i className='ni ni-single-02' />
                  <span>Meus Dados</span>
                </DropdownItem>
                <DropdownItem to='/admin/resume-sync' tag={Link}>
                  <i className='ni ni-settings-gear-65' />
                  <span>{`Sincronizações: ${syncRequests()}`}</span>
                </DropdownItem>
                <DropdownItem onClick={toggle}>
                  <i className='ni ni-fat-remove' />
                  <span>{`Limpar Dados Offiline`}</span>
                </DropdownItem>
                <DropdownItem>
                  <i className='ni ni-cloud-download-95' />
                  <LocalForageBackup />
                </DropdownItem>
                {/* <DropdownItem>
                  <i className='ni ni-cloud-upload-96' />
                  <LocalForageRestore />
                </DropdownItem> */}
                <Modal isOpen={modal} toggle={toggle} {...props}>
                  <ModalHeader toggle={toggle}>
                    Limpar dados Offiline
                  </ModalHeader>
                  <ModalBody>
                    Esta ação deve ser feita, quando deseja-se fazer um reset
                    dos dados offiline da aplicação. Este recurso apagará, caso
                    tiver também sincronizações existentes. Então antes de
                    executar esta ação, faça a sincronização para não perder os
                    dados registrados.
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color='primary'
                      onClick={() => {
                        toggle();
                        localforage.clear();
                        setSyncRequests(0);
                        Notification(200, 'Dados excluídos com sucesso!');
                      }}
                    >
                      Aplicar
                    </Button>{' '}
                    <Button color='secondary' onClick={toggle}>
                      Cancelar
                    </Button>
                  </ModalFooter>
                </Modal>
                <DropdownItem divider />
                <DropdownItem href='#pablo' onClick={logout}>
                  <i className='ni ni-user-run' />
                  <span>Sair</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
